import { render, staticRenderFns } from "./volunteer-common.vue?vue&type=template&id=576ba712&scoped=true"
import script from "./volunteer-common.vue?vue&type=script&lang=js"
export * from "./volunteer-common.vue?vue&type=script&lang=js"
import style0 from "./volunteer-common.vue?vue&type=style&index=0&id=576ba712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ba712",
  null
  
)

export default component.exports